import { render, staticRenderFns } from "./MHelpFrame.vue?vue&type=template&id=0818fc0f&"
import script from "./MHelpFrame.vue?vue&type=script&lang=ts&"
export * from "./MHelpFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports